export const STATUS = {
  survey_cancel: 'survey_cancel',
  new_save: 'new_save',
  news_save: 'news_save',
  approved_done: 'approved_done',
}